import React from 'react';
import c from './Modal.module.css';

const Modal = ({ show, onClose, children }) => {
  if (!show) return null; // Don't render anything if 'show' is false

  return (
    <div className={c.overlay} onClick={onClose}>
      <div className={c.contentCtr} onClick={(e) => e.stopPropagation()}>
        {/* This is where you can put any content you want */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
